var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSignupBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1185,
    height: 140,
    viewBox: "0 0 1185 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_4810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.494,
    y: -281.365,
    width: 211.626,
    height: 458.078,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.494 -255.247C436.494 -269.672 448.188 -281.365 462.612 -281.365H622.002C636.427 -281.365 648.12 -269.672 648.12 -255.247V119.787C648.12 134.212 636.427 145.906 622.002 145.906H436.494V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.494 -255.247C436.494 -269.672 448.188 -281.365 462.612 -281.365H548.334C562.759 -281.365 574.453 -269.672 574.453 -255.247V119.787C574.453 134.212 562.759 145.906 548.334 145.906H436.494V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.494 -264.623C436.494 -273.87 443.99 -281.365 453.237 -281.365C462.483 -281.365 469.979 -273.87 469.979 -264.623V-8.79599C469.979 5.62885 458.285 17.3224 443.861 17.3224H436.494V-264.623Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.492 -255.247C436.492 -269.672 424.799 -281.365 410.374 -281.365H355.458C341.033 -281.365 329.34 -269.672 329.34 -255.247V20.671C329.34 35.0958 341.033 46.7895 355.458 46.7895H436.492V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.492 46.7903H427.786C413.361 46.7903 401.668 58.4839 401.668 72.9088V145.906H436.492V46.7903Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.338 -83.1325H321.971C307.547 -83.1325 295.853 -71.4389 295.853 -57.0141V17.323H329.338V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.453 -53.6657H568.426C554.001 -53.6657 542.308 -41.9721 542.308 -27.5473V46.7898H574.453V-53.6657Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.494,
    y: -182.251,
    width: 261.185,
    height: 229.039,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.76,
    y: -246.541,
    width: 53.5763,
    height: 358.961,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.855 -83.1325H596.552C610.977 -83.1325 622.671 -71.4389 622.671 -57.0141V86.3025C622.671 100.727 610.977 112.421 596.552 112.421H295.855V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.855 275.828H603.249C617.674 275.828 629.368 264.135 629.368 249.71V138.539C629.368 124.114 617.674 112.421 603.249 112.421H295.855V275.828Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.957 249.71C244.957 264.135 256.65 275.828 271.075 275.828H401.668V138.539C401.668 124.114 389.974 112.421 375.549 112.421H271.075C256.65 112.421 244.957 124.114 244.957 138.539V249.71Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.455,
    y: -115.279,
    width: 229.039,
    height: 360.301,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.455,
    y: 17.3225,
    width: 334.852,
    height: 356.282,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.078 139.998H430.227C430.418 138.822 430.937 137.537 431.812 136.143C433.563 133.381 437.09 130.674 440.125 130.045V128.896C438.621 128.568 437.145 127.885 435.723 126.873C432.824 124.822 430.691 121.76 430.227 118.998H429.078C428.805 120.447 428.176 121.842 427.191 123.264C425.25 126.08 422.215 128.158 419.125 128.896V130.045C420.684 130.373 422.27 131.139 423.828 132.314C427 134.693 428.668 137.646 429.078 139.998Z",
    fill: "url(#paint0_linear_21_4810)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.953 18H329.102C329.293 16.8242 329.812 15.5391 330.688 14.1445C332.438 11.3828 335.965 8.67578 339 8.04688V6.89844C337.496 6.57031 336.02 5.88672 334.598 4.875C331.699 2.82422 329.566 -0.238281 329.102 -3H327.953C327.68 -1.55078 327.051 -0.156251 326.066 1.26562C324.125 4.08203 321.09 6.16016 318 6.89844V8.04688C319.559 8.375 321.145 9.14063 322.703 10.3164C325.875 12.6953 327.543 15.6484 327.953 18Z",
    fill: "url(#paint1_linear_21_4810)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_21_4810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 211.626,
    height: 458.078,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 154.694 -282.035)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.363 -255.247C155.363 -269.672 143.67 -281.365 129.245 -281.365H-30.1444C-44.5693 -281.365 -56.2629 -269.672 -56.2629 -255.247V119.787C-56.2629 134.212 -44.5693 145.906 -30.1444 145.906H155.363V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.363 -255.247C155.363 -269.672 143.67 -281.365 129.245 -281.365H43.523C29.0981 -281.365 17.4045 -269.672 17.4045 -255.247V119.787C17.4045 134.212 29.0981 145.906 43.523 145.906H155.363V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.363 -264.623C155.363 -273.87 147.868 -281.365 138.621 -281.365C129.374 -281.365 121.878 -273.87 121.878 -264.623V-8.79599C121.878 5.62885 133.572 17.3224 147.997 17.3224H155.363V-264.623Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.365 -255.247C155.365 -269.672 167.059 -281.365 181.483 -281.365H236.399C250.824 -281.365 262.518 -269.672 262.518 -255.247V20.671C262.518 35.0958 250.824 46.7895 236.399 46.7895H155.365V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.365 46.7903H164.071C178.496 46.7903 190.19 58.4839 190.19 72.9088V145.906H155.365V46.7903Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.519 -83.1325H269.886C284.311 -83.1325 296.005 -71.4389 296.005 -57.0141V17.323H262.519V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.408 -53.6657H23.4353C37.8601 -53.6657 49.5538 -41.9721 49.5538 -27.5473V46.7898H17.408V-53.6657Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00803047 74.9055C9.66812 74.5532 17.4043 66.5979 17.4043 56.8357L17.4043 46.7901L-0.00803293 46.7901L-0.00803047 74.9055Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 261.185,
    height: 229.039,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 154.694 -182.92)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 53.5763,
    height: 358.961,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 315.426 -247.211)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.004 -83.1325H-4.6929C-19.1177 -83.1325 -30.8113 -71.4389 -30.8113 -57.0141V86.3025C-30.8113 100.727 -19.1177 112.421 -4.69287 112.421H296.004V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.004 275.828H-11.39C-25.8148 275.828 -37.5084 264.135 -37.5084 249.71V138.539C-37.5084 124.114 -25.8148 112.421 -11.39 112.421H296.004V275.828Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.903 249.71C346.903 264.135 335.209 275.828 320.784 275.828H190.192V138.539C190.192 124.114 201.885 112.421 216.31 112.421H320.784C335.209 112.421 346.903 124.114 346.903 138.539V249.71Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 229.039,
    height: 360.301,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 383.735 -115.948)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 334.852,
    height: 356.282,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 383.735 16.6528)",
    stroke: "#363746",
    strokeWidth: 1.33941
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_21_4810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1028.71,
    y: -281.365,
    width: 211.626,
    height: 458.078,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 -255.247C1028.71 -269.672 1040.4 -281.365 1054.83 -281.365H1214.22C1228.64 -281.365 1240.34 -269.672 1240.34 -255.247V119.787C1240.34 134.212 1228.64 145.906 1214.22 145.906H1028.71V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 -255.247C1028.71 -269.672 1040.4 -281.365 1054.83 -281.365H1140.55C1154.97 -281.365 1166.67 -269.672 1166.67 -255.247V119.787C1166.67 134.212 1154.97 145.906 1140.55 145.906H1028.71V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 -264.623C1028.71 -273.87 1036.2 -281.365 1045.45 -281.365C1054.7 -281.365 1062.19 -273.87 1062.19 -264.623V-8.79599C1062.19 5.62885 1050.5 17.3224 1036.08 17.3224H1028.71V-264.623Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 -255.247C1028.71 -269.672 1017.02 -281.365 1002.59 -281.365H947.675C933.25 -281.365 921.557 -269.672 921.557 -255.247V20.671C921.557 35.0958 933.25 46.7895 947.675 46.7895H1028.71V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.71 46.7903H1020C1005.58 46.7903 993.885 58.4839 993.885 72.9088V145.906H1028.71V46.7903Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.555 -83.1325H914.188C899.763 -83.1325 888.07 -71.4389 888.07 -57.0141V17.323H921.555V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.67 -53.6657H1160.64C1146.22 -53.6657 1134.52 -41.9721 1134.52 -27.5473V46.7898H1166.67V-53.6657Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.08 74.9055C1174.41 74.5532 1166.67 66.5979 1166.67 56.8357L1166.67 46.7901L1184.08 46.7901L1184.08 74.9055Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1028.71,
    y: -182.251,
    width: 261.185,
    height: 229.039,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.976,
    y: -246.541,
    width: 53.5763,
    height: 358.961,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.072 -83.1325H1188.77C1203.19 -83.1325 1214.89 -71.4389 1214.89 -57.0141V86.3025C1214.89 100.727 1203.19 112.421 1188.77 112.421H888.072V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.072 275.828H1195.47C1209.89 275.828 1221.58 264.135 1221.58 249.71V138.539C1221.58 124.114 1209.89 112.421 1195.47 112.421H888.072V275.828Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.174 249.71C837.174 264.135 848.867 275.828 863.292 275.828H993.884V138.539C993.884 124.114 982.191 112.421 967.766 112.421H863.292C848.867 112.421 837.174 124.114 837.174 138.539V249.71Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 799.67,
    y: -115.279,
    width: 229.039,
    height: 360.301,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 799.67,
    y: 17.3225,
    width: 334.852,
    height: 356.282,
    rx: 26.1185,
    stroke: "#363746",
    strokeWidth: 1.33941
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_21_4810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 211.626,
    height: 458.078,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 746.911 -282.035)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.58 -255.247C747.58 -269.672 735.887 -281.365 721.462 -281.365H562.072C547.648 -281.365 535.954 -269.672 535.954 -255.247V119.787C535.954 134.212 547.648 145.906 562.072 145.906H747.58V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.58 -255.247C747.58 -269.672 735.887 -281.365 721.462 -281.365H635.74C621.315 -281.365 609.621 -269.672 609.621 -255.247V119.787C609.621 134.212 621.315 145.906 635.74 145.906H747.58V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.58 -264.623C747.58 -273.87 740.084 -281.365 730.838 -281.365C721.591 -281.365 714.095 -273.87 714.095 -264.623V-8.79599C714.095 5.62885 725.789 17.3224 740.214 17.3224H747.58V-264.623Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.582 -255.247C747.582 -269.672 759.275 -281.365 773.7 -281.365H828.616C843.041 -281.365 854.734 -269.672 854.734 -255.247V20.671C854.734 35.0958 843.041 46.7895 828.616 46.7895H747.582V-255.247Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.582 46.7903H756.288C770.713 46.7903 782.406 58.4839 782.406 72.9088V145.906H747.582V46.7903Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.734 -83.1325H862.101C876.526 -83.1325 888.219 -71.4389 888.219 -57.0141V17.323H854.734V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.623 -53.6657H615.65C630.075 -53.6657 641.769 -41.9721 641.769 -27.5473V46.7898H609.623V-53.6657Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 261.185,
    height: 229.039,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 746.911 -182.92)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 53.5763,
    height: 358.961,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 907.641 -247.211)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.219 -83.1325H587.522C573.097 -83.1325 561.404 -71.4389 561.404 -57.0141V86.3025C561.404 100.727 573.097 112.421 587.522 112.421H888.219V-83.1325Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.219 275.828H580.825C566.4 275.828 554.706 264.135 554.706 249.71V138.539C554.706 124.114 566.4 112.421 580.825 112.421H888.219V275.828Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.115 249.71C939.115 264.135 927.422 275.828 912.997 275.828H782.405V138.539C782.405 124.114 794.098 112.421 808.523 112.421H912.997C927.422 112.421 939.115 124.114 939.115 138.539V249.71Z",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 229.039,
    height: 360.301,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 975.95 -115.948)",
    stroke: "#363746",
    strokeWidth: 1.33941
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.669704,
    y: 0.669704,
    width: 334.852,
    height: 356.282,
    rx: 26.1185,
    transform: "matrix(-1 0 0 1 975.95 16.6528)",
    stroke: "#363746",
    strokeWidth: 1.33941
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_4810",
    x1: 429.625,
    y1: 118.998,
    x2: 429.625,
    y2: 139.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "#262839"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_4810",
    x1: 328.5,
    y1: -3,
    x2: 328.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836992,
    stopColor: "#262839"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.186,
    y: -200.331,
    width: 297.348,
    height: 597.376,
    rx: 16.0729,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_21_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297.348,
    height: 597.376,
    rx: 16.0729,
    transform: "matrix(-1 0 0 1 296.672 -200.331)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_21_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 887.402,
    y: -200.331,
    width: 297.348,
    height: 597.376,
    rx: 16.0729,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_21_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297.348,
    height: 597.376,
    rx: 16.0729,
    transform: "matrix(-1 0 0 1 888.889 -200.331)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSignupBanner);
export default __webpack_public_path__ + "static/media/bgSignupBanner.7d7d0fd1e6f28bddba8b760e9fd883b9.svg";
export { ForwardRef as ReactComponent };